module.exports = __webpack_public_path__ + "assets/img/4.d15ace18.png";